/**
 * @generated SignedSource<<0f1a649330bf451d8c5980375a3e9e56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreviewNoteTemplate$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"MetadataNoteTemplate">;
  readonly " $fragmentType": "PreviewNoteTemplate";
};
export type PreviewNoteTemplate$key = {
  readonly " $data"?: PreviewNoteTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreviewNoteTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreviewNoteTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MetadataNoteTemplate"
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "693310751b8e3bab87b0e30e7560a20a";

export default node;
